"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _merge = _interopRequireDefault(require("lodash/merge"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../hooks/useIsomorphicLayoutEffect"));
var _Button = require("../Button");
var _SelectTrigger = _interopRequireDefault(require("./components/SelectTrigger"));
var _SelectFilter = _interopRequireDefault(require("./components/SelectFilter"));
var _types = require("./types");
var _i18n2 = _interopRequireDefault(require("./i18n.json"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var getLabel = function getLabel(items, placeholder) {
  var selectedLabels = [];
  items.forEach(function (i) {
    var _a;
    if (i.selected && !i.indeterminate && i.label) {
      selectedLabels.push(i.label);
    } else {
      (_a = i === null || i === void 0 ? void 0 : i.nested) === null || _a === void 0 ? void 0 : _a.forEach(function (k) {
        if (k.selected && k.label) {
          selectedLabels.push(k.label);
        }
      });
    }
  });
  if (selectedLabels.length) {
    return selectedLabels.join(', ');
  } else {
    return placeholder;
  }
};
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var triggerProps = props.triggerProps,
    onClickOutside = props.onClickOutside,
    closeOnScrollOutside = props.closeOnScrollOutside,
    placeholder = props.placeholder,
    listProps = props.listProps,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    onChange = props.onChange,
    onApply = props.onApply,
    onReset = props.onReset,
    width = props.width,
    minWidth = props.minWidth,
    _b = props.type,
    type = _b === void 0 ? _types.SelectTypes.Select : _b,
    _c = props.closeOnSelect,
    closeOnSelect = _c === void 0 ? false : _c,
    _d = props.isMultiSelect,
    isMultiSelect = _d === void 0 ? false : _d,
    _e = props.showResetButton,
    showResetButton = _e === void 0 ? false : _e,
    _f = props.showApplyButton,
    showApplyButton = _f === void 0 ? false : _f,
    state = props.state,
    disabled = props.disabled,
    showFilter = props.showFilter,
    i18n = props.i18n,
    filterdProps = __rest(props, ["triggerProps", "onClickOutside", "closeOnScrollOutside", "placeholder", "listProps", "items", "onChange", "onApply", "onReset", "width", "minWidth", "type", "closeOnSelect", "isMultiSelect", "showResetButton", "showApplyButton", "state", "disabled", "showFilter", "i18n"]);
  var previousIsOpenState = (0, _react.useRef)(false);
  var shouldfocusTrigger = (0, _react.useRef)(false);
  var initiatedRef = (0, _react.useRef)(false);
  var filterRef = (0, _react.useRef)(null);
  var _g = (0, _react.useState)(getLabel(items, placeholder)),
    label = _g[0],
    setLabel = _g[1];
  var _h = (0, _react.useState)(''),
    filterValue = _h[0],
    setFilterValue = _h[1];
  var _j = (0, _react.useState)(items),
    slectItems = _j[0],
    setSelectItems = _j[1];
  var _k = (0, _react.useState)(null),
    triggerRef = _k[0],
    setTriggerRef = _k[1];
  var _l = (0, _react.useState)(),
    listRef = _l[0],
    setListRef = _l[1];
  var _m = (0, _react.useState)(width),
    triggerWidth = _m[0],
    setTriggerWidth = _m[1];
  var _o = (0, _react.useState)(!width && !minWidth ? true : false),
    isOpen = _o[0],
    setIsOpen = _o[1];
  var _i18n = (0, _react.useMemo)(function () {
    return (0, _merge.default)(_i18n2.default, i18n);
  }, [i18n]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      open: function open() {
        return setIsOpen(true);
      },
      close: function close() {
        return setIsOpen(false);
      }
    };
  }, []);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    if (!width && !minWidth) {
      if (listRef && triggerWidth === undefined) {
        var listRect = listRef.getBoundingClientRect();
        setTriggerWidth(listRect.width + 38);
        setIsOpen(false);
        initiatedRef.current = true;
        shouldfocusTrigger.current = true;
      }
    } else {
      initiatedRef.current = true;
      shouldfocusTrigger.current = true;
    }
  }, [width, minWidth, listRef, triggerWidth]);
  (0, _react.useEffect)(function () {
    setLabel(getLabel(items, placeholder));
  }, [items, placeholder]);
  (0, _react.useEffect)(function () {
    if (showFilter && filterValue.length) {
      var updatedItems = items.map(function (item) {
        var _a, _b;
        var shouldIncludeHit = false;
        var updatedItem = __assign({}, item);
        if ((_a = updatedItem.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filterValue.toLowerCase())) {
          shouldIncludeHit = true;
        }
        if ((_b = updatedItem.nested) === null || _b === void 0 ? void 0 : _b.length) {
          updatedItem.nested = updatedItem.nested.filter(function (nestedItem) {
            var _a;
            if ((_a = nestedItem.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filterValue.toLowerCase())) {
              shouldIncludeHit = true;
              return true;
            } else {
              return false;
            }
          });
        }
        if (shouldIncludeHit) {
          return updatedItem;
        } else {
          return null;
        }
      }).filter(function (i) {
        return i;
      });
      setSelectItems(updatedItems);
    } else {
      setSelectItems(items);
    }
  }, [showFilter, filterValue, items]);
  (0, _react.useEffect)(function () {
    if (shouldfocusTrigger.current) {
      if (!isOpen && previousIsOpenState.current && triggerRef) {
        triggerRef.focus();
      }
    }
  }, [isOpen, triggerRef]);
  (0, _react.useEffect)(function () {
    if (initiatedRef.current) {
      previousIsOpenState.current = isOpen;
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    if (isOpen && listRef) {
      if (document.activeElement !== listRef) {
        listRef.focus();
      }
    }
    if (!isOpen) {
      setFilterValue('');
    }
  }, [isOpen, listRef]);
  var handleOnClickOutside = (0, _react.useCallback)(function (event) {
    if (typeof onClickOutside === 'function') {
      onClickOutside(event);
    }
    setIsOpen(false);
  }, [onClickOutside]);
  var toggleOpen = (0, _react.useCallback)(function () {
    setIsOpen(function (current) {
      return !current;
    });
  }, []);
  var handleOnFilterChange = (0, _react.useCallback)(function (value) {
    setFilterValue(value);
  }, []);
  var handleOnfilterKeyDown = (0, _react.useCallback)(function (event) {
    var _a, _b, _c, _d;
    event.stopPropagation();
    switch (event.code) {
      case 'ArrowUp':
        {
          (_a = listRef === null || listRef === void 0 ? void 0 : listRef.handleOnKeyDown) === null || _a === void 0 ? void 0 : _a.call(listRef, event);
          break;
        }
      case 'ArrowDown':
        {
          (_b = listRef === null || listRef === void 0 ? void 0 : listRef.handleOnKeyDown) === null || _b === void 0 ? void 0 : _b.call(listRef, event);
          break;
        }
      case 'Enter':
        {
          (_c = listRef === null || listRef === void 0 ? void 0 : listRef.handleOnKeyDown) === null || _c === void 0 ? void 0 : _c.call(listRef, event);
          break;
        }
      default:
        (_d = listRef === null || listRef === void 0 ? void 0 : listRef.setFocus) === null || _d === void 0 ? void 0 : _d.call(listRef, false);
    }
  }, [listRef]);
  var handleOnListFocus = (0, _react.useCallback)(function () {
    if (filterRef.current) {
      filterRef.current.focus({
        preventScroll: true
      });
    }
  }, []);
  var handleOnKeyDown = (0, _react.useCallback)(function (event) {
    if (typeof (listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown) === 'function') {
      listProps.onKeyDown(event);
    }
    if (isOpen) {
      switch (event.code) {
        case 'Escape':
          {
            event.preventDefault();
            event.stopPropagation();
            setIsOpen(false);
          }
      }
    }
  }, [isOpen, listProps]);
  var handleOnChange = (0, _react.useCallback)(function (items) {
    if (typeof onChange === 'function') {
      onChange(items);
    }
    if (!isMultiSelect || closeOnSelect) {
      setIsOpen(false);
    }
  }, [closeOnSelect, isMultiSelect, onChange]);
  var handleOnMainSelect = (0, _react.useCallback)(function (selectedItem) {
    var updatedItmes = items.map(function (i) {
      var _a;
      if (i.id === selectedItem.id) {
        var isNextSelected_1 = Array.isArray(i.nested) && i.nested.length ? i.nested.every(function (i) {
          return i.selected;
        }) ? false : true : !i.selected;
        return __assign(__assign({}, i), {
          selected: isNextSelected_1,
          indeterminate: false,
          nested: (_a = i === null || i === void 0 ? void 0 : i.nested) === null || _a === void 0 ? void 0 : _a.map(function (k) {
            return __assign(__assign({}, k), {
              selected: isNextSelected_1
            });
          })
        });
      } else {
        if (isMultiSelect) {
          return i;
        } else {
          return __assign(__assign({}, i), {
            selected: false
          });
        }
      }
    });
    handleOnChange(updatedItmes);
  }, [handleOnChange, items, isMultiSelect]);
  var handleOnNestedSelect = (0, _react.useCallback)(function (selectedItem) {
    var updatedItems = items.map(function (i) {
      var _a;
      if (i.id === selectedItem.parentId) {
        var nextNested = ((_a = i === null || i === void 0 ? void 0 : i.nested) === null || _a === void 0 ? void 0 : _a.map(function (k) {
          if (k.id === selectedItem.id) {
            return __assign(__assign({}, k), {
              selected: k.selected ? false : true
            });
          } else {
            return k;
          }
        })) || [];
        return __assign(__assign({}, i), {
          selected: nextNested.every(function (j) {
            return j.selected;
          }),
          indeterminate: !nextNested.every(function (j) {
            return j.selected;
          }) && nextNested.some(function (j) {
            return j.selected;
          }),
          nested: nextNested
        });
      } else {
        return i;
      }
    });
    handleOnChange(updatedItems);
  }, [handleOnChange, items]);
  var handleOnApply = (0, _react.useCallback)(function () {
    if (typeof onApply === 'function') {
      onApply();
    }
    setIsOpen(false);
  }, [onApply]);
  var handleOnReset = (0, _react.useCallback)(function () {
    var updatedItmes = items.map(function (item) {
      return __assign(__assign({}, item), {
        selected: false,
        indeterminate: false,
        nested: Array.isArray(item.nested) ? item.nested.map(function (nestedItem) {
          return __assign(__assign({}, nestedItem), {
            selected: false
          });
        }) : item.nested
      });
    });
    handleOnChange(updatedItmes);
    if (typeof onReset === 'function') {
      onReset();
    }
  }, [handleOnChange, items, onReset]);
  var withFooter = showResetButton || showApplyButton;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_SelectTrigger.default, __assign({
      ref: setTriggerRef
    }, triggerProps, {
      style: __assign({
        width: triggerWidth,
        minWidth: minWidth
      }, triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.style),
      label: label,
      state: state,
      isOpen: isOpen,
      disabled: disabled,
      toggleOpen: toggleOpen
    })), (0, _jsxRuntime.jsxs)(Styled.Popover, __assign({}, filterdProps, {
      ref: undefined,
      offset: {
        x: -1,
        y: -2
      },
      show: isOpen,
      anchor: triggerRef,
      onClickOutside: handleOnClickOutside,
      onScrollOutside: closeOnScrollOutside ? toggleOpen : undefined
    }, {
      children: [showFilter && (0, _jsxRuntime.jsx)(_SelectFilter.default, {
        ref: filterRef,
        style: {
          width: triggerWidth,
          minWidth: minWidth
        },
        value: filterValue,
        onChange: handleOnFilterChange,
        onKeyDown: handleOnfilterKeyDown
      }), (0, _jsxRuntime.jsx)(Styled.List, __assign({
        type: type
      }, listProps, {
        // @ts-ignore
        ref: setListRef,
        onSelect: handleOnMainSelect,
        onKeyDown: handleOnKeyDown,
        onFocus: handleOnListFocus,
        "$withFooter": withFooter,
        style: {
          width: triggerWidth,
          minWidth: minWidth,
          marginTop: showFilter ? -1 : undefined
        }
      }, {
        children: slectItems.map(function (item) {
          return (0, _jsxRuntime.jsx)(Styled.SelectListItem, __assign({}, item, {
            value: item,
            onSelect: handleOnMainSelect
          }, {
            children: Array.isArray(item.nested) && item.nested.length ? item.nested.map(function (nestedItem) {
              return (0, _jsxRuntime.jsx)(Styled.SelectListItem, __assign({}, nestedItem, {
                targeted: false,
                "$isNested": true,
                value: nestedItem,
                onSelect: handleOnNestedSelect
              }), nestedItem.id);
            }) : undefined
          }), item.id);
        })
      })), withFooter ? (0, _jsxRuntime.jsxs)(Styled.Footer, __assign({
        style: {
          width: triggerWidth,
          minWidth: minWidth
        }
      }, {
        children: [showResetButton ? (0, _jsxRuntime.jsx)(Styled.ResetButton, __assign({
          onClick: handleOnReset,
          size: _Button.ButtonSizes.Small,
          variant: _Button.ButtonVariants.Text,
          variantType: _Button.ButtonVariantTypes.Link
        }, {
          children: _i18n.reset
        })) : null, showApplyButton ? (0, _jsxRuntime.jsx)(Styled.ApplyButton, __assign({
          onClick: handleOnApply,
          size: _Button.ButtonSizes.Small
        }, {
          children: _i18n.apply
        })) : null]
      })) : null]
    }))]
  });
});
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;